import { ProductOrderDetails } from "../../../../shared/types/productAvailabilityTypes"
import { MonetaryAmount } from "../../../currency/currencyTypes"
import { Allergen, OfferDetailsType, ProductStockInfo } from "../products/productsTypes"

export enum CurrencyCode {
    DKK = "DKK",
}

export enum PriceAdjustmentType {
    REDUCTION = "REDUCTION",
    INCREASE = "INCREASE",
    NONE = "NONE",
}

export type CreateOrEditPriceListFormValues = Readonly<{
    name: string
    isActive: boolean
    shops: number[]
    messageToCustomers?: string
    internalNote: string
    priceAdjustmentType: string
    percentage: string
    currencyCode: string
    vatCodeId?: string
    isDefaultPOSPriceList?: boolean
    priceIncludesVat: boolean
    customers: Customer[]
    cardSubscriptions: Omit<CardSubscription, "description">[]
    products: Products[]
}>

export type PriceListCreate = Readonly<{
    merchant: {
        id: number
    }
    name: string
    isActive: boolean
    messageToCustomers?: string
    internalNote: string
    priceIncludesVat: boolean
    priceSetup: {
        currencyCode: string
        vatCodeId?: number
        priceAdjustment: {
            type: string
            percentage: {
                amount: number
                scale: number
            }
        }
    }
    customers: Customer[]
    isDefaultPOSPriceList?: boolean
    cardSubscriptions: {
        id: number
    }[]
    shops: {
        id: number
    }[]
}>

export type Customer = Readonly<{
    id: number
    name: string
    userGroups: UserGroup[]
}>

export type Products = Readonly<{
    id: number
    productNumber: string
    description?: string
    name: string
    isActive: boolean
    price: MonetaryAmount
    adjustedPrice: MonetaryAmount
    imageUrl?: string
    offerDetails?: OfferDetailsType
    userDetails?: ProductUserDetails
    paymentDetails?: {
        isPriceHidden: boolean
    }
    itemLimits?: {
        minItemsPerOrder: number
    }
    stock?: ProductStockInfo
    orderDetails?: ProductOrderDetails
    productDescription?: {
        marketingTag: string
        allergens: Allergen[]
    }
}>

export type Shop = Readonly<{
    id: number
    name: string
}>

export type MerchantVatCode = Readonly<{
    id: number
    code: string
    name: string
    vatPercentage: {
        amount: number
        scale: number
    }
}>

export type DetailedProductGroups = Readonly<{
    id: number
    name: string
    products: Products[]
}>

export type DetailedPriceList = Readonly<{
    id: number
    name: string
    isActive: boolean
    messageToCustomers: string
    internalNote: string
    priceIncludesVat: boolean
    priceSetup?: {
        currencyCode: string
        priceAdjustment: {
            type: PriceAdjustmentType
            percentage: {
                amount: number
                scale: number
            }
        }
        vatCode?: {
            code: string
            id: number
            name: string
            vatPercentage: {
                amount: number
                scale: number
            }
        }
    }
    cardSubscriptions?: Array<Omit<CardSubscription, "description">>
    isDefaultPOSPriceList?: boolean
    shops?: Shop[]
    customers?: Customer[]
    productGroups: DetailedProductGroups[]
    history: {
        created: {
            timestamp: string
            author: string
        }
        updated: {
            timestamp: string
            author: string
        }
    }
}>

type UserGroup = Readonly<{
    id: number
    name: string
}>

export type CustomerFlat = Readonly<{
    customerId: number
    customerName: string
    userGroupId: number
    isOfficeHotel?: boolean
    userGroupName: string
}>

export type CardSubscription = Readonly<{
    id: number
    name: string
    description: string
}>

export type ProductUserDetails = Readonly<{
    favoriteType: string
    favoriteId: number
    canFavorite: boolean
    isFavorite: boolean
}>
